import React from 'react';

const Logo = ({ size = 'md', showText = true, className = '' }) => {
  const sizes = {
    sm: { h: 28, text: 'text-lg' },
    md: { h: 36, text: 'text-2xl' },
    lg: { h: 50, text: 'text-3xl' },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center ${className}`}>
      <img src="/logo.png" alt="layanan.umroh" height={s.h} className="h-auto" style={{ height: s.h, width: 'auto' }} />
      {showText && (
        <span className={`${s.text} font-semibold font-['Outfit'] ml-2 leading-none`}>
          <span className="text-[#1E293B] dark:text-white">layanan</span>
          <span className="text-[#C9A84C]">.umroh</span>
        </span>
      )}
    </div>
  );
};

export default Logo;
